<div class="container">
    <br>
    <div class="row">
        <div class="col-sm-7 col-12 title-trends">Tendencias nacionales</div>
        <div class="col-sm-5 col-12">
            <div class="row justify-content-end">
                <a class="col-3" routerLink="../tendencia-global">
                    <img class="icon-trends" src="assets/img/t/tg-w.webp" alt="Tendencia global"></a>
                <a class="col-3" routerLink="../tendencia-nacional">
                    <img class="icon-trends" src="assets/img/t/tn-b.webp" alt="Tendencia nacional"></a>
                <a class="col-3" routerLink="../tendencia-territorial">
                    <img class="icon-trends" src="assets/img/t/tt-w.webp" alt="Tendencia territorial"></a>
                <a class="col-3" routerLink="../tendencia-sectorial">
                    <img class="icon-trends" src="assets/img/t/ts-w.webp" alt="Tendencia sectorial"></a>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <p class="col-12"><b>Fenómeno consistente en el tiempo</b> que se manifiesta en el país. Se identifica dado el
            <b>comportamiento local</b> de las variables que la componen y que <b>inciden en el desarrollo nacional</b>
            actual y
            en el mediano o largo plazo
        </p>
    </div>
    <!-- Start carousel -->
    <app-carousel [idTier1ForSlider]="idTier1"></app-carousel>
    <!-- End carousel -->
    <div class="row">
        <div class="col-md-12">
            <p class="py-4">Seleccione una temática para explorar las principales tendencias nacionales:</p>
        </div>
        <br>
        <br>
        <div class="col-sm-3 col-md-4">
            <div id="hexas-national"></div>
        </div>
        <div class="col-sm-9 col-md-8" *ngIf="tematicT3">
            <div class="row">
                <div class="col-6 col-sm-4 col-md-3 col-elements" *ngFor="let p of tematicT3">
                    <div class="card-elements" routerLink="../ficha/{{p.code}}">
                        <div class="btn-trends">
                            <i class="fa fa-location-arrow" aria-hidden="true"></i>
                            <div class="box-text-btn">{{p.shorttitle}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>